import { render } from "./App.vue?vue&type=template&id=08bc386b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=08bc386b&lang=scss"

import exportComponent from "F:\\PROMODUL\\Projets\\OBSERVATOIRE-BAS-CARBONE.FR\\VueJS_Plugin\\fdcp-vue-posts-filter\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__